import { connect } from "react-redux";
import EditRenewContract from "./EditRenewContract";
import { bindActionCreators } from "redux";
import {
  getContractDataForRenewal,
  renewalSaveEditData
} from "services/redux/brandActivtion/sitesListing/action";
import {
  documentUploadUrl,
  imageUploadUrl,
  videoUploadUrl,
} from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
    contractData: state.baSiteListingReducer.contractDataForRenewal,
    documentUrlData: state.fileUploadReducer.documentUrlData
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
          documentUploadUrl,
          getContractDataForRenewal,
          renewalSaveEditData
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(EditRenewContract);
